import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/lathe-grey.jpg'


const _hoisted_1 = {
  class: "about-section text-center",
  id: "about"
}
const _hoisted_2 = { class: "container px-4 px-lg-5" }
const _hoisted_3 = { class: "row gx-4 gx-lg-5 justify-content-center" }
const _hoisted_4 = { class: "col-lg-8" }
const _hoisted_5 = { class: "text-white-50" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LinkComponent = _resolveComponent("LinkComponent")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[3] || (_cache[3] = _createElementVNode("h2", { class: "text-white mb-4" }, " hand-crafted flutes, headjoints & whistles ", -1)),
          _createElementVNode("div", _hoisted_5, [
            _cache[1] || (_cache[1] = _createElementVNode("p", null, [
              _createTextVNode(" ironwood is a small one-person workshop in the beautiful German region of "),
              _createElementVNode("i", null, "Eifel"),
              _createTextVNode(". After several years spent building whistles, I now focus on "),
              _createElementVNode("b", null, "Irish flutes"),
              _createTextVNode(" and wooden "),
              _createElementVNode("b", null, "headjoints for Boehm flutes"),
              _createTextVNode(" — and still make whistles on request. I do not mass produce or use industrialized processes: each instrument is turned, voiced and finished by using a combination of CNC-precision and manual work, with devotion to the craft. ")
            ], -1)),
            _cache[2] || (_cache[2] = _createElementVNode("p", null, [
              _createElementVNode("img", {
                src: _imports_0,
                class: "w-100"
              })
            ], -1)),
            _createElementVNode("p", null, [
              _createVNode(_component_LinkComponent, {
                "link-text": "Contact ironwood",
                href: "#contact",
                inverted: true
              }),
              _cache[0] || (_cache[0] = _createTextVNode(" for available instruments or a custom commission. ", -1))
            ])
          ])
        ])
      ])
    ])
  ]))
}